import type { ShouldRevalidateFunction } from '@remix-run/react';

const MODAL_CONTENT_GATE = 'content_gate';
const MODAL_EMAIL_CAPTURE = 'email_capture';

const IGNORABLE_MODALS = [MODAL_CONTENT_GATE, MODAL_EMAIL_CAPTURE];

export const shouldRevalidateLoaderData: ShouldRevalidateFunction = ({
  nextUrl,
  currentUrl,
  defaultShouldRevalidate,
  formAction,
  formData,
}) => {
  const isCreatingLogin = formAction === '/create_login';

  const isRequestingMagicLink = formData?.get('request_magic_link') === 'true';

  if (isCreatingLogin && isRequestingMagicLink) {
    return false;
  }

  if (formAction === '/posts_insights' || formAction === '/page_view') {
    return false;
  }

  const currentModalParamValue = currentUrl.searchParams.get('modal');
  const nextModalParamValue = nextUrl.searchParams.get('modal');

  // Don't revalidate page when content gate/email capture modal opens, except
  // when content gate modal is closed to fix a bug where client-side changes
  // to isContentClipped aren't properly reflected on first page load with
  // certain search parameters
  if (currentModalParamValue && IGNORABLE_MODALS.includes(currentModalParamValue)) {
    return currentModalParamValue === MODAL_CONTENT_GATE && nextModalParamValue === null;
  }

  if (!isCreatingLogin && nextModalParamValue) {
    return false;
  }

  if (!isCreatingLogin && currentModalParamValue && !nextModalParamValue) {
    return false;
  }

  return defaultShouldRevalidate;
};
